import { ServiceSessionUserEvent } from '@modules/ServiceModule';
import { InboxContext } from '../types';
import TasksModule from '@modules/TasksModule';
import { TaskState } from '@modules/TasksModule/types';
import { setCallToTimedOut } from '../callHandlers/callStateHandler';

/**
 * The session reject event is fired whenever a session is rejected by the agent OR the user times out.
 *
 * `setExternalCallToTimedOut` will only set the state to TIMEDOUT if the task is in the OFFERED state.
 *
 * In the case of a timeout, the task will be in the OFFERED state and this handler will set the state to TIMEDOUT.
 *
 * In the case the agent rejects the call, `handleTaskReject` will set the task to REJECTED state. By the time this event fires,
 * the task should already be in the REJECTED state, `setExternalCallToTimedOut` will do nothing if the task in the REJECTED state.
 */
function handleSessionRejected(
  context: InboxContext,
  event: ServiceSessionUserEvent,
) {
  const task = TasksModule.getTask(event.sessionSid);

  if (!task) {
    return;
  }

  // in general we should not get session events for an outbound call
  // if we do, it means that the user called into a queue and now is receiving events for the same session
  // because it was routed back to them and Kazoo rejected it automatically for them.
  // We don't need to do anything in this scenario.
  if (task.isOutbound) {
    return;
  }

  if (context.userId === event.userId && task.state === TaskState.Offered) {
    // only do for current user
    setCallToTimedOut({
      context,
      sessionSid: event.sessionSid,
      eventType: 'session-rejected',
    });
  }
}

export default handleSessionRejected;
